import { useEffect } from 'react';
import { storeAnswerToStorage } from 'packages/signup/helpers/storageHelpers';
import type {
  NumberEmployeesSegmentationValues,
  RunPayrollValues,
  PrevPayrollProviderValues,
  IndustryIdentificationValues,
  IntentStepValues,
  WhatToUseValues,
  WhatToUseFindYourPlanValues,
  WhoToPayValues,
  NumberStatesValues,
} from 'packages/signup/components/SurveyQuestions';

/*
  Syncs tofu answers to the HomepageSurveyAnswers localstorage key.
  Still needed since we are using the old Signup form component.
  This should be removed once we create the new form
*/
export enum StorageKeys {
  TOFU_SURVEY = 'HomepageSurveyAnswers',
  HOW_GUSTO_WORKS_SURVEY = 'HowGustoWorksSurveyAnswers',
}

export default function useSyncWithOldLocalStorage(
  numberEmployeesSegmentation: NumberEmployeesSegmentationValues | undefined,
  runPayroll: RunPayrollValues | undefined,
  prevPayrollProvider: PrevPayrollProviderValues | undefined,
  industryIdentification: IndustryIdentificationValues | undefined,
  intentStep: IntentStepValues | undefined,
  whoToPay: WhoToPayValues | undefined,
  numberStates: NumberStatesValues | undefined,
  whatToUse: WhatToUseValues | string[],
  whatToUseFindYourPlan: WhatToUseFindYourPlanValues | string[]
) {
  useEffect(() => {
    if (runPayroll) {
      storeAnswerToStorage('RUN_PAYROLL', runPayroll, StorageKeys.TOFU_SURVEY);
    }
  }, [runPayroll]);

  useEffect(() => {
    if (numberEmployeesSegmentation) {
      storeAnswerToStorage(
        'NUMBER_EMPLOYEES_SEGMENTATION',
        numberEmployeesSegmentation,
        StorageKeys.TOFU_SURVEY
      );
    }
  }, [numberEmployeesSegmentation]);

  useEffect(() => {
    if (prevPayrollProvider) {
      storeAnswerToStorage('PREV_PAYROLL_PROVIDER', prevPayrollProvider, StorageKeys.TOFU_SURVEY);
    }
  }, [prevPayrollProvider]);

  useEffect(() => {
    if (industryIdentification) {
      storeAnswerToStorage(
        'INDUSTRY_IDENTIFICATION',
        industryIdentification,
        StorageKeys.TOFU_SURVEY
      );
    }
  }, [industryIdentification]);

  useEffect(() => {
    if (intentStep) {
      storeAnswerToStorage('INTENT_STEP', intentStep, StorageKeys.TOFU_SURVEY);
    }
  }, [intentStep]);

  useEffect(() => {
    if (whoToPay) {
      storeAnswerToStorage('WHO_TO_PAY', whoToPay, StorageKeys.HOW_GUSTO_WORKS_SURVEY);
    }
  }, [whoToPay]);

  useEffect(() => {
    if (numberStates) {
      storeAnswerToStorage('NUMBER_STATES', numberStates, StorageKeys.HOW_GUSTO_WORKS_SURVEY);
    }
  }, [numberStates]);

  useEffect(() => {
    if (prevPayrollProvider) {
      storeAnswerToStorage(
        'PREV_PAYROLL_PROVIDER',
        prevPayrollProvider,
        StorageKeys.HOW_GUSTO_WORKS_SURVEY
      );
    }
  }, [prevPayrollProvider]);

  useEffect(() => {
    if (whatToUse) {
      storeAnswerToStorage('WHAT_TO_USE', whatToUse.toString(), StorageKeys.HOW_GUSTO_WORKS_SURVEY);
    }
  }, [whatToUse]);

  useEffect(() => {
    if (whatToUseFindYourPlan) {
      storeAnswerToStorage(
        'WHAT_TO_USE_FIND_YOUR_PLAN',
        whatToUseFindYourPlan.toString(),
        StorageKeys.HOW_GUSTO_WORKS_SURVEY
      );
    }
  }, [whatToUseFindYourPlan]);
}
